module.exports = __webpack_public_path__ + "static/img/14000081.5fbf2d43.png";